import { APIError } from "@/adapters/api";
import type { OvertimeRateField } from "../types";
import { OVERTIME_RATE_FIELDS } from "./schedule";

const REASON_MESSAGES: Record<string, string> = {
	"holiday-already-exists": "Já existe feriado nesta data.",
	"holiday-not-deletable": "Feriados nacionais não podem ser removidos.",
	"holidays-import-failed":
		"Não foi possível consultar os feriados nacionais. Tente novamente.",
	"holidays-year-unsupported":
		"Não há feriados nacionais disponíveis para este ano.",
};

const VIOLATION_MESSAGES: Record<string, string> = {
	required: "Obrigatório",
	invalid: "Inválido",
	incomplete: "Informe todos os dias da semana",
	duplicated: "Dia repetido",
	before_starts_at: "O fim deve ser depois do início",
	gte_duration: "O intervalo não pode cobrir toda a jornada",
};

export function violationMessage(description: string): string {
	const known = VIOLATION_MESSAGES[description];
	if (known) return known;
	const bound = description.match(/^(lt|gt):(-?\d+)$/);
	if (bound) {
		return bound[1] === "lt"
			? `Deve ser no mínimo ${bound[2]}`
			: `Deve ser no máximo ${bound[2]}`;
	}
	return description;
}

export function timeSettingsErrorMessage(
	err: unknown,
	fallback: string,
): string {
	if (!(err instanceof APIError)) return fallback;
	const known = REASON_MESSAGES[err.reason] ?? REASON_MESSAGES[err.code];
	if (known) return known;
	return err.message || fallback;
}

export type TimeSettingsFieldPath =
	| OvertimeRateField
	| `schedule.${number}.startsAt`
	| `schedule.${number}.endsAt`
	| `schedule.${number}.breakMinutes`
	| "schedule";

const SCHEDULE_FIELDS: Record<string, "startsAt" | "endsAt" | "breakMinutes"> =
	{
		starts_at: "startsAt",
		ends_at: "endsAt",
		break_minutes: "breakMinutes",
	};

export function violationFieldPath(
	field: string,
): TimeSettingsFieldPath | undefined {
	const rate = OVERTIME_RATE_FIELDS.find((r) => r.apiField === field);
	if (rate) return rate.name;
	if (field === "schedule") return "schedule";
	const match = field.match(/^schedule\[(\d+)\]\.(\w+)$/);
	if (!match) return undefined;
	const index = Number(match[1]);
	const key = SCHEDULE_FIELDS[match[2] ?? ""];
	return key ? `schedule.${index}.${key}` : undefined;
}
